import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import {
  ApplicationMain,
  ApplicationMainMenu,
  AppDetailPage,
  AppsPage,
  ContactPage,
  EngineeringPage,
  EulaPrivacy,
  GamesPage,
  SiteFooter,
  dayFocus,
  picPerfect3,
  retroPocketToys,
  susLink,
} from "./components/common";
import { Routes, Route } from "react-router-dom";
import { useMenuItems } from "./components/common/hooks/useMenuItems";
import { useScrollToTop } from "./components/common/hooks/useScrollToTop";

function App() {
  // Hooks
  const { mainMenuItemList } = useMenuItems();
  useScrollToTop();

  return (
    <div className="App">
      <ApplicationMainMenu
        id="application-main-menu"
        className="application-menu"
        menuItems={mainMenuItemList}
      />
      <main>
        <Routes>
          {/* Routes below are referenced from App Store Connect — do not change these paths. */}
          <Route path="/" element={<ApplicationMain />} />
          <Route path="/home" element={<ApplicationMain />} />
          <Route path="/login" element={<ApplicationMain />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/eula_privacy" element={<EulaPrivacy />} />

          <Route path="/apps" element={<AppsPage />} />
          <Route
            path="/apps/pic-perfect-3"
            element={<AppDetailPage product={picPerfect3} />}
          />
          <Route
            path="/apps/dayfocus"
            element={<AppDetailPage product={dayFocus} />}
          />
          <Route
            path="/apps/suslink"
            element={<AppDetailPage product={susLink} />}
          />
          <Route path="/games" element={<GamesPage />} />
          <Route
            path="/games/retro-pocket-toys"
            element={<AppDetailPage product={retroPocketToys} />}
          />

          <Route path="/engineering" element={<EngineeringPage />} />

          <Route path="*" element={<ApplicationMain />} />
        </Routes>
      </main>
      <SiteFooter />
    </div>
  );
}

export default App;
